import { OrdresFabricationTab } from "@features/production/components/OrdresFabricationTab";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { ClipboardList } from "lucide-react";

export const Route = createFileRoute("/_app/production/ordres-fabrication/")({
  loader: requirePermission(PERMISSIONS.PRODUCTION.OF.VIEW),
  staticData: {
    title: "Ordres de Fabrication",
    icon: ClipboardList,
    tab_icon: ClipboardList,
    permission: PERMISSIONS.PRODUCTION.OF.VIEW,
    section: "App",
    module: "production",
    order: 20,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
    description: "Gestion des ordres de fabrication",
  },
  component: OrdresFabricationTab,
});
